module.exports = __webpack_public_path__ + "static/scale-model-of-ann-arbor-hands-on-museum-in-ann-arbor-michigan-ae877d0615f751823e30e6b0f12c93e3.png";